<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <swiper-slide class="slide">
    <router-link
      title="Click to open article"
      :to="{ name: 'article', params: { idOrName: link } }"
    >
      <div
        v-if="!loading"
        class="slide-image slider-image-height"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      ></div>
      <div
        v-if="loading"
        class="slide-image"
        style="background-color: #e2e2e2;"
      ></div>
      <div class="slide-footer">
        <v-clamp
          autoresize
          :max-lines="1"
          class="slide-footer-title"
          :title="title"
          >{{ title }}</v-clamp
        >
        <v-clamp
          autoresize
          :max-lines="1"
          class="slide-footer-subtitle"
          :title="subtitle"
        >
          {{ subtitle }}
        </v-clamp>
        <v-clamp
          v-if="content"
          autoresize
          :max-lines="1"
          class="slide-footer-content"
          :title="content"
          >{{ content }}</v-clamp
        >
      </div>
    </router-link>
  </swiper-slide>
</template>
<script>
import VClamp from "vue-clamp";

export default {
  components: {
    VClamp
  },
  props: {
    backgroundImage: {
      type: String,
      required: true
    },
    link: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    content: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./../../../styles/index";

.slide-footer-content {
  margin-top: 1rem;
  font-size: 1.8rem;
  line-height: 1.8rem;
  //max-width: calc(100vw - #{2 * $page-side-margin-size} - 5rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @include mobile() {
    display: none;
  }
}
</style>
<style lang="scss">
@import "./../../../styles/index";

.slide {
  position: relative;

  a {
    color: $body-color;
  }

  &-image {
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
  }

  &-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 7.5rem;
    background-color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 1rem 1.5rem 1rem 1.5rem;

    @include mobile {
      height: 3.5rem;
    }

    &-title {
      font-size: 2rem;
      line-height: 2rem;
      font-weight: bold;

      @include mobile {
        font-size: 1.1rem;
        line-height: 1.1rem;
      }
    }

    &-subtitle {
      font-size: 1.3rem;
      line-height: 1.3rem;
      margin-top: 0.5rem;
      font-style: italic;
      color: #646464;

      @include mobile {
        font-size: 0.9rem;
        line-height: 0.9rem;
      }
    }
  }
}
</style>
<style lang="scss">
@import "./slider-unscoped";

.slider-image-height {
  height: $slide-height;

  @include mobile {
    height: $slide-height-mobile;
  }
}
</style>
